<template>
    <div class="lang">
        <div class="info">
            <h3 class="bullet01">国际医疗保健中心</h3>
            <p class="depth">
                梨花女子大学医学中心的国际医疗保健中心在对患者友好的环境中为国际患者提供全面的医疗保健服务. 我们与驻韩美军, 国际紧急救援组织和阿布扎比卫生局等外国政府机构，以及世界各地的医疗机构已经建立的长期关系是我们宝贵的资产，这种关系有助于我们更好地为全球各类患者服务. 我们提供急救护理, 非卧床护理, 门诊, 住院治疗和健康促进检查方案，致力于健康和创新，最终为全球患者及其家人提供最佳的治疗护理.
            </p>
        </div>
        <div class="info">
            <h3 class="bullet01">礼宾和协调员服务</h3>
            <p class="depth">
                梨花女子大学医疗中心为来自60多个国家的国际患者提供医疗服务. 医疗中心特聘请了受过高等教育，有着经验丰富的医务人员和协调员，可提供英语、汉语、俄语以及阿拉伯语. 为特殊顾客提供不同的文化项目，还准备了礼宾服务与贵宾病房等项目，让患者享受到最舒适的体验.
            </p>
        </div>
        <div class="info">
            <h3 class="bullet01">一站式服务</h3>
            <p class="depth">
                我们非常理解，对海外顾客来讲时间是很宝贵的，因此，我们的协调员为顾客提供从门诊预约到办理出院手续以及酒店预订、机场接送等一站式服务.
            </p>
        </div>
        <div class="info">
            <h3 class="bullet01">工作时间 (国际医疗保健中心)</h3>
            <div class="info information-call__box">
                <div class="information-call__img"><img alt="" src="/resource/icon/phon.png">
                    <h4 class="pc-none">工作日 : 09:00 ~ 17:00</h4>
                </div>

                <div class="information-call__text">
                    <h4 class="mo-none">工作日 : 09:00 ~ 17:00</h4>

                    <p>
                        星期六 : 关闭 <br>
                        星期日及公众假期 : 请至一楼的急救中心就诊
                    </p>
                </div>
            </div>
        </div>
        <div class="info">
            <h3 class="bullet01">地点 (国际医疗保健中心)</h3>
            <h4 class="bullet02">国际医疗保健中心位于一楼.</h4>
            <div class="layout mt20">
                <div class="layout__inner">
                    <div class="layout__info">
                        <div class="layout__store">
                            <h4 class="layout__store-tit">1F</h4>
                            <ul class="layout__store-list">
                                <!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if-->
                                <li class="layout__store-item active">
                                    <button type="button"><span>10</span>International Healthcare Center</button>
                                </li><!--v-if--><!--v-if-->
                                
                            </ul>
                        </div>
                        <div class="layout__map">
                            <!-- <h3 class="tit"><span class="num">{{current.floor}}</span><span class="circle"></span></h3> -->
                            <div class="pin active" style="bottom: 27%;right:calc(9.7% - 26px)"><img
                                    src="/resource/icon/pin.svg" alt="이미지" class="active"></div><img
                                src="/displayFile.do?name=20241128.1527.25.184.jpg" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>